var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{staticStyle:{"transform":"scale(1.3)"},attrs:{"type":"checkbox","name":_vm.firstLast + _vm.inputId,"disabled":_vm.isDisabled},domProps:{"checked":_vm.checked},on:{"click":_vm.checkedBox}})])}
var staticRenderFns = []

export { render, staticRenderFns }